export default {
  root: {
    width: '100%',
    '&:not(:first-of-type)': { mt: { xs: 3, lg: 5 } },
  },
  detailsBox: {
    display: 'flex',
    gap: 1.5,
    height: 'fit-content',
    mt: 2,
  },
  iconBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'fit-content',
    minHeight: { xs: 26, lg: 40 },
  },
  icon: {
    width: { xs: 24, lg: 28 },
    height: { xs: 24, lg: 28 },
  },
  textBox: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
};
